

















































































































import {
  computed, defineComponent, PropType, Ref, ref, watch,
} from 'vue';
import { TableRow } from 'multinet';

import api from '@/api';
import { randomPhrase } from '@/utils/randomPhrase';

export default defineComponent({
  props: {
    selection: {
      type: Array as PropType<string[]>,
      required: true,
    },

    workspace: {
      type: String as PropType<string>,
      required: true,
    },
  },

  setup(props, { emit }) {
    const dialog = ref(false);
    const confirmationPhrase = ref('');
    const confirmation = ref('');
    const using: Ref<Array<{network: string; tables: string[]}>> = ref([]);

    const plural = computed(() => (props.selection.length > 1 ? 's' : ''));
    const nonZeroSelection = computed(() => props.selection.length > 0);
    const dependentNetworks = computed(() => using.value.length > 0);

    async function execute() {
      await Promise.all(props.selection.map((table) => api.deleteTable(props.workspace, table)));
      dialog.value = false;
    }

    async function findDependentNetworks() {
      function tableName(tableRow: TableRow) {
        // eslint-disable-next-line no-underscore-dangle
        return tableRow._id.split('/')[0];
      }

      const networkNames = (await api.networks(props.workspace)).results.map((network) => network.name);
      const dependents = [] as Array<{network: string; tables: string[]}>;
      networkNames.forEach(async (network) => {
        const nodes = await api.nodes(props.workspace, network, {});
        const edges = await api.edges(props.workspace, network, {
          direction: 'all',
        });

        const prelimNodes = nodes.results.map((node) => tableName(node));
        const nodeTables: string[] = [];
        prelimNodes.forEach((table) => {
          if (!nodeTables.includes(table)) {
            nodeTables.push(table);
          }
        });
        const edgeTable = edges.results.length > 0 ? tableName(edges.results[0]) : '';
        const tables: string[] = [];
        props.selection.forEach((table) => {
          if (table === edgeTable || nodeTables.includes(table)) {
            tables.push(table);
          }
        });

        if (tables.length > 0) {
          dependents.push({
            network,
            tables,
          });
        }
      });

      return dependents;
    }

    function clear() {
      confirmationPhrase.value = '';
      confirmation.value = '';
    }

    watch(dialog, async () => {
      if (dialog.value) {
        using.value = [];
        const dependents = await findDependentNetworks();
        if (dependents.length > 0) {
          using.value = dependents;
        } else {
          clear();
          confirmationPhrase.value = randomPhrase();
        }
      } else {
        emit('closed');
      }
    });

    return {
      dialog,
      confirmationPhrase,
      confirmation,
      using,
      plural,
      nonZeroSelection,
      dependentNetworks,
      execute,
    };
  },
});
